/**
 * DEC-1030: pure — maps a failed /beta-access/redeem HTTP status to the
 * gate's error key. Lives in its own module (no axios/React imports) so it
 * is unit-testable under CRA's jest, which can't transform axios ESM.
 * null/undefined status = network-level failure (no HTTP response at all).
 */
export function redeemErrorFromStatus(status) {
  if (status === 410) return 'expired';   // expired / revoked / consumed
  if (status === 404 || status === 400) return 'invalid';
  return 'error';                          // 5xx / network — try again
}
